import {Component, EventEmitter, Input, Output} from '@angular/core';
import {PaginatedResponse} from "@generated-backend-types";
import {PaginationModule} from "ngx-bootstrap/pagination";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'app-table-pagination',
  templateUrl: './table-pagination.component.html',
  styleUrls: ['./table-pagination.component.scss'],
  imports: [PaginationModule, FormsModule],
  standalone: true
})
export class TablePaginationComponent<T> {
  @Output() public goToPage = new EventEmitter<number>()
  @Input() data!: PaginatedResponse<T>
}
